import "core-js/stable";
import "regenerator-runtime/runtime";

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

import objectFitImages from 'object-fit-images';
objectFitImages();

import './_toggle.js';
// import './_splide.js';
import './_years.js';
import './_scroll-out.js';
import './_swiper.js';
import './_copybord.js';
import './_table-textdomain.js';
import './_sticky-top.js';
import './_morebutton.js';
import './_page-transition.js';
import './_image-class.js';

import { toggleBodyClass } from './_class/_toggle';

document.querySelector('.menu-icon__wrap').addEventListener('click', toggleBodyClass('menu-open'));
document.querySelector('.side-menu-icon-left__wrap').addEventListener('click', toggleBodyClass('side-menu-left-open'));
('.site-header--side-left')
const buttonElement = document.querySelector('#example .wp-block-button__link');
if (buttonElement) {
  buttonElement.addEventListener('click', toggleBodyClass('slide-example-close'));
}
// document.querySelector('.sitemap').addEventListener('click', toggleBodyClass('menu-open'));

var imgElements = document.querySelectorAll('a img');
if (imgElements.length > 0) {
  imgElements.forEach(function(img) {
    var aTag = img.closest('a');
    if (aTag && !aTag.closest('p') && !aTag.closest('h1, h2, h3, h4, h5, h6')) {  // 親要素がpではないaタグにクラスを付与
      aTag.classList.add('not-in-p');
    }
  });
}

  const body = document.body;
  const menuOverlay = document.querySelector('.menu-overlay');
  // メニュー外をクリックしたら閉じる
  menuOverlay.addEventListener('click', () => {
    body.classList.remove('side-menu-left-open');
  });